import { ENDPOINTS } from '@/configs/endpoints';
import { NewsDigestOption, newsDigestOptionSchema } from '@/entities/News';
import { FieldSelectStore } from '@/stores/local/shared/form/FieldSelectStore';
import call from '@/utils/api';
import { BaseResponse } from '@/utils/api/types';
import { schemeParseMultiple } from '@/utils/schemeParse';

import { ConstructorParams, NewsDigestOptionsResponseApi, OptionsParams } from './types';

export class NewsDigestSelectStore extends FieldSelectStore<NewsDigestOption> {
  constructor({ organizationId }: ConstructorParams) {
    super({
      getOptions: (params: OptionsParams) => NewsDigestSelectStore._getOptions(params, organizationId),
    });
  }

  private static async _getOptions(
    params: OptionsParams,
    organizationId: number,
  ): Promise<BaseResponse<{ items: NewsDigestOption[]; total: number }>> {
    const response = await call<NewsDigestOptionsResponseApi>({
      endpoint: ENDPOINTS.news.digests(String(organizationId)),
      data: {
        search: params.search || undefined,
      },
    });

    if (response.isError) {
      return {
        isError: true,
        error: response.error,
      };
    }

    const rawData = Array.isArray(response.data) ? response.data : (response.data.items ?? []);

    const parsed = schemeParseMultiple(newsDigestOptionSchema, rawData);

    return {
      isError: false,
      data: {
        items: parsed,
        total: parsed.length,
      },
    };
  }
}
